/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type WebhookKind = typeof WebhookKind[keyof typeof WebhookKind];


export const WebhookKind = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
